import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function TripCollectionShipmentAmount({
    label,
    options,
    isTripCollectionShipmentAmounts,
    onChange,
    isEditable,
}) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={isTripCollectionShipmentAmounts}
                options={options}
                onSave={onChange}
                isEditable={isEditable}
            />
        </EuiFlexItem>
    );
}
